import { createAction } from 'redux-actions'
import { createRequestActions as request } from 'store/actionCreators/createRequestActions'

export const setTopNotificationBlockShown = createAction<string>('LOCAL_SETTINGS/setTopNotificationBlockShown')

/** handled by saga @see ./saga/onGetSubscriptionState.js */
export const onGetSubscriptionState = createAction<string>('LOCAL_SETTINGS/onGetSubscriptionState')

export const onSetSubscriptionState = createAction<string>('LOCAL_SETTINGS/onSetSubscriptionState')

/** handled by saga @see ./saga/onSubscribePush.js */
export const onSubscribePush = createAction<string>('LOCAL_SETTINGS/onSubscribePush')

export const onNotificationsBlocked = createAction<string>('LOCAL_SETTINGS/onNotificationsBlocked')

export const setNotificationsPending = createAction<string>('LOCAL_SETTINGS/setNotificationsPending')

/** handle by saga @see ./saga/initOneSignal.js */
export const initOneSignal = createAction<string>('LOCAL_SETTINGS/initOneSignal')

export const initOneSignalSuccess = createAction<string>('LOCAL_SETTINGS/initOneSignalSuccess')

export const setConfirmationModal = createAction<string>('LOCAL_SETTINGS/isShowConfirmationModalForSwitchProTrack')

export const setConfirmationModalForStopProTrack = createAction<string>(
  'LOCAL_SETTINGS/isShowConfirmationModalForStopProTrack'
)

export const setConfirmationModalForCommitPreviousActivity = createAction<boolean>(
  'LOCAL_SETTINGS/isShowConfirmationModalForCommitPreviousActivity'
)

export const setConfirmationModalForDifferentProTrack = createAction<boolean>(
  'LOCAL_SETTINGS/isShowConfirmationModalForDifferentProTrack'
)

export const closeShowLoginInformationModal = createAction<string>('LOCAL_SETTINGS/closeShowLoginInformationModal')

export const loadLanguages = createAction<string>('LOCAL_SETTINGS/LOAD_LANGUAGES')

// set queries for help
export const setQueries = createAction<string>('LOCAL_SETTINGS/SET_QUERIES')

export const fetchCountriesCodes = request('UI/FETCH_COUNTRIES_CODES', () => ({
  request: {
    url: '/countries-codes',
  },
}))

export const triggerCommitOrDidPreviousActivities = createAction<any>(
  'LOCAL_SETTINGS/triggerCommitOrDidPreviousActivities'
)

export const setShouldAutoPlayVideo = createAction<any>('LOCAL_SETTINGS/setShouldAutoPlayVideo')
